import logo from 'images/communities/Baltimore/logo.svg'
import dashboardHeaderImage from 'images/communities/Baltimore/banner.jpg'
import mapHeaderImage from 'images/communities/Baltimore/landing.jpg'
import loginBackgroundImg from 'images/communities/Baltimore/background-image.jpg'
import favicon from 'images/communities/Baltimore/favicon.png'
import homeLogo from 'images/home/community-logos/baltimore.png'
import { SURVEY_QUESTIONS } from 'types'
import videoImage from 'images/map/video/video-button-image.svg'

const config = {
  subdomain: 'baltimore',
  name: 'Baltimore',
  position: 11,
  partnerSupportEmail: 'support@artseveryday.org',
  schoolSupportEmail: 'support@artseveryday.org',
  artistSupportEmail: 'support@artseveryday.org',
  stylesheet: 'baltimore.scss',
  mapRedirectPath: '/partner-portal',
  organizationUrl: 'https://artseveryday.org/',
  faqUrl:
    'https://drive.google.com/file/d/1Fwxkr3MKMx3Id747FQwVObMJl5Vhi_dZ/view?usp=share_link',
  mapEnabled: true,
  schoolPortalEnabled: false,
  partnerPortalEnabled: false,
  partnerProfileCompletionEnabled: false,
  schoolProfileCompletionEnabled: false,
  teachingArtistProfileCompletionEnabled: false,
  showRecentLoginOnPublicPage: false,
  partnerProgramsEnabled: false,
  googleLoginEnabled: true,
  portalSignInEnabled: true,
  educatorEnabled: false,
  notificationsEnabled: true,
  notificationListSize: -1,
  dataDashboardEnabled: true,
  partnerRegisterEnabled: false,
  id: 79,
}

// ----- Teaching Artist -----
config.teachingArtist = {
  enabled: false,
  registerEnabled: false,
  provideOwnPrograms: false,
}

config.teachingArtistRegister = {
  fields: {
    firstName: {
      visible: true,
      required: true,
    },
    lastName: {
      visible: true,
      required: true,
    },
    email: {
      visible: true,
      required: true,
    },
    address: {
      visible: true,
      required: true,
    },
    yearsOfExperience: {
      visible: true,
      required: true,
    },
    description: {
      visible: true,
      required: true,
    },
    website: {
      visible: true,
      required: false,
    },
    disciplines: {
      visible: true,
      required: true,
    },
    profilePicture: {
      visible: true,
      required: false,
    },
    backgroundCheckFile: {
      visible: false,
      required: false,
    },
    pronouns: {
      visible: false,
      required: false,
    },
    demographic: {
      visible: false,
      required: false,
    },
    idealWage: {
      visible: true,
      required: false,
    },
  },
}

// ----- SEARCH -----
config.search = {
  options: {
    blockList: [
      'networks',
      'creativeSchoolsCategory',
      'gradesServed',
      'programDisciplines',
      'programTypes',
      'outcomeTypes',
      'financialAssistanceTypes',
    ],
  },
  schoolSearchFilters: [
    'coursesOffered',
    'network',
    'creativeSchoolsCategory',
    'instructorsTeaching',
    'schoolType',
    'organizationPartnersCount',
    'programsOffered',
    'disciplineInterests',
    'resourceProgramOutcomeInterests',
    'studentDemographics',
    'schoolDistrict',
    'openToPartnerships',
  ],
  map: {
    center: { lat: 39.296987, lng: -76.615586 },
    radius: 40, //in miles
  },
  directoryFilters: {
    blockList: [],
  },
  forumFilters: {
    blockList: [],
  },
}

// ----- BRANDING -----

config.defaultBranding = {
  className: 'bal-community',
  favicon,
  mapLogo: {
    src: logo,
    alt: 'navigate to Arts Every Day homepage',
    link: config.organizationUrl,
  },
  videoImpage: {
    src: videoImage,
    alt: 'Video Image',
  },
  homeLogo: {
    src: homeLogo,
    alt: 'Arts Every Day - Baltimore',
  },
  communityLogo: {
    src: logo,
    alt: 'Arts Every Day - Inspire Students, Enhance Learning',
  },
  dashboardHeader: {
    src: dashboardHeaderImage,
    alt: '',
  },
  loginBackgroundImg: {
    src: loginBackgroundImg,
    alt: '',
  },
  mapHero: {
    src: mapHeaderImage,
    alt: '',
  },
}

// ----- DISPLAY TEXT -----

/**
 * This object overrides the display text that is defined globally with string values that are
 * specific to the organization. Mustache-esque templating is available for dynamic strings using
 * {{ insertFieldName }} for interpolation.
 */

config.displayText = {
  map: {
    title:
      'artlook Map: Increasing Arts Education in Baltimore City Public Schools',
    searchHeader: 'Find Schools & Partners in Baltimore',
    welcomeSearchHeader: 'Explore Arts Education in Baltimore',
    welcomeHeader: `
      How Does artlook Help Arts Education in <span>${config.name}<span>?
    `,
    explorationHeader:
      '<h1>What can you do on artlook<sup>®</sup> Baltimore</h1>',
    explorationSubTitle: 'Here are some examples...',
    welcomeMessage: `
      <div class="columns">
        <div class="column-left">
          <p>
           artlook<sup>®</sup> ${config.name} is a free online hub created to help educators in our region immerse 
           young people in powerful, personally relevant arts learning opportunities.  
          </p>
          <p>
            Developed by Ingenuity in Chicago and customized as a collaboration among local teachers, school and 
            district administrators, arts partners, and AEC staff, provides an up-to-date picture of the people, 
            places, and programs supporting arts learning in Southwestern Pennsylvania. 
          </p>
        </div>
        <div class="column-right">
          <p>
            In addition to the public Map and Directory available on this site, artlook<sup>®</sup> also enhances the 
            way that AEC is able to provide data analysis, reporting, and specialized programs to arts educators, 
            advocates, and funders with the goal of strengthening a diverse, robust arts education system in our region.  
          </p>
          <p>
            AEC invites additional schools and arts partners to join SWPA each year. Learn more about eligibility and 
            how to get on the map at <a href="${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">
            ${config.schoolSupportEmail}</a>
          </p>
        </div>
      </div>
    `,
    findSchoolsCard: `
      <p>
        If you’re an arts organization or teaching artist, search for schools in
        need of programs that you offer. Reach out!
      </p>

      <p>
        If you’re a parent looking for an arts-rich or discipline-specific
        school for your child, find schools that provide what you’re looking
        for.
      </p>
    `,
    findProgramsCard: `
      <p>
        If you’re a school in need of arts programs, partnerships, or resources,
        search for arts orgs that provide what you’re looking for. New arts ed
        partners are waiting to connect!
      </p>
    `,
    findDataCard: `
      <p>
        If you’re an advocate for a stronger, more vibrant arts education
        landscape in ${config.name}, reach out to Arts Ed Collaborative
        <a href="${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">
        ${config.schoolSupportEmail}</a>. We provide data, programming, and other opportunities aimed at strengthening 
        and expanding creative opportunities for our region’s students.
      </p>
    `,
    justExploreCard: `
      <p>
        The artlook<sup>®</sup> SWPA Map contains the most comprehensive picture of arts ed
        in our region - go search, explore, and learn more about the arts in our
        schools -- as well as where we need to bring more arts to more students.
      </p>
    `,
    videoWelcomeTitle: `Welcome To artlook<sup>®</sup> ${config.name}`,
    videoWelcomeMessage: `
      <p>
        This (free!) publicly-available and searchable map is the only one of its kind in Pennsylvania to capture information on arts education from schools, arts organizations, and teaching artists. Using the Search function below, you can explore the arts ed programs and resources available to students in schools and via partners throughout the region.      </p>
      <p>
        The Map and Directory provide an up-to-date picture of what’s happening in arts ed and where, as well as contact info to connect directly to these schools and arts organizations.  GO EXPLORE & CONNECT to bring more arts to more students!
      </p>
    `,
    videoModal: {
      width: '560',
      height: '315',
      srcUrl:
        'https://www.youtube.com/embed/OeqCbofkUi8?si=988vOCj6wdLTqNEW&amp;controls=0',
      iframeTitle: 'Baltimore artlook map welcome video',
    },
    footer: {
      learnMoreAboutArtlook: 'Learn more about artlook<sup>®</sup>',
      contact: "We'd love to hear from you",
    },
    metricScore: {
      title: 'Creative Schools Certification',
      message: `
        The Creative Schools Certification is at the core of the CPS
        Arts Education Plan. It is a summary measure of the quality
        of arts education available in each school, and therefore
        functions as a decision-making roadmap for stakeholders
        working to expand the arts in schools.
      `,
      basedOnSchoolYear:
        ' The Certification information here is based on the {{ schoolYearNumber }} school year.',
    },
  },
  surveyCompletionModal: `
    <h2>Survey Complete!</h2>
    <br />
    <p>Thank you for completing this year's survey! Your responses help us paint a more comprehensive picture of arts education and can help us connect public schools such as yourselves with quality arts programs. You can download a copy of your survey responses on the survey page.</p>
    <br />
    <p><b>Next up: Give your Profile a quick refresh! Update your current year data to make sure everything's spot-on. The more accurate your info, the easier it is to connect with new partners and get discovered by the right ones.</b></p>
  `,
  tagline:
    'The arts, for every student, in every Baltimore City Public School, every day.',
  partnerPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Welcome to <em>artlook<sup>®</sup> Baltimore!</em></h3>
        <p>
          <em>artlook<sup>®</sup> Baltimore</em> is the only platform of its kind that combines data from Baltimore City public schools and arts program providers (like you!). Did you ever wonder what schools need your resources the most? By taking the time to complete your profile, you are joining a collaborative community effort to reach every school in Baltimore City.
        </p>
        <p>
          <strong>To get started, follow the links in the boxes below to share your organization's program and school partnership information. Make sure to complete all sections of your profile.</strong>
          If you have any questions or need assistance, please contact <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener noreferrer">${config.partnerSupportEmail}</a>.
        </p>
      `,
    },
  },
  schoolPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Baltimore</em> is YOUR gallery for arts education data</h3>
        <p>
          <em>artlook<sup>®</sup> Baltimore</em> is the only platform of its kind that combines data from Baltimore-area public schools (like you!) and arts partners. The goal is to collect arts access data and use it to make the case for more funding, better staffing, and improved policies. But we can't do it without you!
        </p>
        <p>
          <strong>
            To get started, complete both steps below: Update Your School Profile to share your partnership interests for the current school year, and Complete the Annual Survey (once it goes live) to share information about your school's arts education offerings from the previous school year.
          </strong>
        </p>
        <p>If you have any questions or need assistance, please contact <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.</p>
      `,
    },
  },
  survey: {
    getStarted: `<h2>Welcome to the {{ surveySchoolYearNumber }} artlook<sup>®</sup> Schools Survey!</h2>
    <p>Through this annual survey, you will be asked to share information about arts education staffing and instruction at your school, partnerships with arts partners (i.e. arts organizations), and how your school budgets and plans for the arts.</p>
    <p>As you work on the {{ surveySchoolYearNumber }} survey, please be sure to frequently save your responses to each question to avoid losing information. You are not required to complete your survey in one session; saving your responses as you go will allow you to return at any time to complete or edit your survey before submitting.</p>
    <p>If you have any questions or need assistance, please contact <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.</p>`,
    staffingQuestion: {
      modalMessage: `
        <p>
        <strong>Note on instructors:</strong> Restrict the list of instructors in your school to those teaching an arts course during the school day.
        </p>
        <p>
        <strong>Note on part/full-time status:</strong> Please select Full Time if a teacher had full-time status for the entire school year. If a teacher was part-time for all or part of the year, or full-time for only part of the year, please select Part Time.
        </p>
        <p>
        <strong>Note on disciplines:</strong> The Primary Focus of each instructor is required. You may optionally list a Secondary Focus as well. Please also select the “Classroom/non-arts teacher?” button if the instructor is not primarily an arts instructor (e.g., non-arts, general education teacher teaching arts courses).
        </p>
        `,
      displayOptions: {
        showClassNumber: true,
      },
    },
    instructorQuestion: {
      displayOptions: {
        showInstructorEmail: true,
      },
    },
    scholarshipQuestion: {
      displayOptions: {
        showExample: true,
      },
    },
  },
  artistPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Welcome to artlook – A Home for Teaching Artists!</h3>
        <p>
          We're excited to have you join our vibrant community of teaching artists, educators, and organizations passionate about arts education. Whether you're here to showcase your talents, connect with schools and partners, or discover new opportunities, this platform is designed to support your journey
        </p>
        <p>
          Start by building your profile, sharing your experience, and exploring collaborations. Together, we can inspire creativity and make a lasting impact through the arts.
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.artistSupportEmail}" target="_blank" rel="noopener noreferrer">${config.artistSupportEmail}</a>.
        </p>
      `,
    },
  },
}

// ----- SURVEY QUESTIONS CONFIG -----

const {
  APPROACHES,
  GOVERNANCE,
  OBSTACLES_SELECT,
  OBSTACLES_DESCRIBE,
  OBSTACLES_OVERCOME,
  DISTRICT_SPENDING,
  COMMUNITY_ENGAGEMENTS,
} = SURVEY_QUESTIONS

config.surveyQuestions = {
  approaches: APPROACHES.OPTIONS.PER_DISCIPLINE,
  governance: GOVERNANCE.OPTIONS.GENERAL,
  obstaclesSelect: OBSTACLES_SELECT.OPTIONS.GENERAL,
  obstaclesDescribe: OBSTACLES_DESCRIBE.OPTIONS.GENERAL,
  obstaclesOvercome: OBSTACLES_OVERCOME.OPTIONS.GENERAL,
  districtSpending: DISTRICT_SPENDING.OPTIONS.GENERAL,
  communityEngagement: COMMUNITY_ENGAGEMENTS.OPTIONS.GENERAL,
}

export default config
